import data from './projects.json'
let projects = {
  list: [
    { value: 'prj01', text: 'Conformación de Semilleros TIC.' },
    { value: 'prj02', text: 'Fortalecimiento de las competencias básicas de los estudiantes.' },
    { value: 'prj021', text: 'Semilleros de cultura ciudadana.' },
    { value: 'prj03', text: 'Implementación de sistemas de gestión de calidad escolar.' },
    { value: 'prj031', text: 'Gestión calidad: Mediadores de comunicación' },
    { value: 'prj04', text: 'Mejoramiento de la gestión curricular.' },
    { value: 'prj05', text: 'Fortalecimiento de las instituciones educativas rurales con proyectos pedagógicos productivos pertinentes.' },
    { value: 'prj06', text: 'Recreación en actividades lúdicas para niños y niñas de la primera infancia.' },
    { value: 'prj07', text: 'Adecuación de espacios de ludoteca.' },
    { value: 'prj08', text: 'Recreación a través de la Iniciación y Formación Deportiva.' },
    { value: 'prj09', text: 'Fortalecimiento de las competencias básicas desde la oferta formativa en arte y cultura.' },
    { value: 'prj10', text: 'Capacitación en iniciación y sensibilización artística en comunas y corregimientos.' }
  ],

  'prj01': {
    incipiente:{
      schools: [
        'INSTITUCION EDUCATIVA ALBERTO CARVAJAL BORRERO',
        'INSTITUCION EDUCATIVA ALFONSO LOPEZ PUMAREJO',
        'INSTITUCION EDUCATIVA BARTOLOMÉ LOBOGUERRERO',
        'INSTITUCION EDUCATIVA CARLOS HOLMES TRUJILLO',
        'INSTITUCION EDUCATIVA CIUDAD CORDOBA',
        'INSTITUCION EDUCATIVA CRISTOBAL COLON',
        'INSTITUCION EDUCATIVA EL DIAMANTE',
        'INSTITUCION EDUCATIVA EL HORMIGUERO',
        'INSTITUCION EDUCATIVA EUSTAQUIO PALACIOS',
        'INSTITUCION EDUCATIVA EVA RIASCOS PLATA',
        'INSTITUCION EDUCATIVA EVARISTO GARCIA',
        'INSTITUCION EDUCATIVA FELIDIA',
        'INSTITUCION EDUCATIVA FRANCISCO JOSE LLOREDA MERA'
      ],
      resume: 'Lorem'
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj02': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj021': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj03': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj031': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj04': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj05': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj06': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj07': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj08': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj09': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  },
  'prj10': {
    incipiente:{
    },
    desarrollo:{
    },
    intermedio:{
    },
    maduracion:{
    },
    robusto:{
    }
  }
}
projects = data
export default projects
